import { Link } from "react-router-dom";
import { useBlog } from "../context/BlogContext";

export default function Blog() {
  const { posts } = useBlog();
  const sorted = [...posts].sort((a, b) => b.date.localeCompare(a.date));

  return (
    <div className="page blog-page">
      <header className="page-header">
        <h1>Blog</h1>
        <p>Occasional notes on research, reading, and life in academia.</p>
      </header>

      <div className="blog-list">
        {sorted.map((post) => (
          <article key={post.id} className="blog-teaser">
            <time dateTime={post.date}>
              {new Date(post.date + "T12:00:00").toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </time>
            <h2>
              <Link to={`/blog/${post.id}`}>{post.title}</Link>
            </h2>
            <p>{post.excerpt}</p>
            <Link to={`/blog/${post.id}`} className="text-link">
              Read more
            </Link>
          </article>
        ))}
      </div>
    </div>
  );
}
